// Invoice Letterhead Choice (advance module, Super Admin → Manage Modules →
// Advanced). One company, one set of books — but on Sale Invoice and Non-Tax
// Sale Invoice prints the user picks whose details print at the top:
//   'company' → the company's own details (exactly as before)
//   <id>      → one of the extra letterheads saved in Print Settings
//   'blank'   → no company details at all (everything else prints the same)
// Module off = no picker, prints as before.
// Firebase cost: nothing — the letterheads live in the print settings document
// the invoice screens already load; the last choice is remembered on the device.

export const INVOICE_LETTERHEAD_MODULE = 'print_invoice_letterheads';

export const MAX_INVOICE_LETTERHEADS = 10;

export const EMPTY_INVOICE_LETTERHEAD = { name: '', address: '', phone: '', email: '', ntn: '', salesTaxNo: '' };

/** The saved extra letterheads (with a name) from the print settings document. */
export const listInvoiceLetterheads = (printConfig) =>
  (Array.isArray(printConfig?.invoiceLetterheads) ? printConfig.invoiceLetterheads : [])
    .filter((l) => l && l.id && String(l.name || '').trim());

const storeKey = (companyId) => `amalInvoiceLetterhead|${companyId || ''}`;

export const lastLetterheadChoice = (companyId) => {
  try { return window.localStorage.getItem(storeKey(companyId)) || 'company'; } catch (e) { return 'company'; }
};

export const rememberLetterheadChoice = (companyId, choice) => {
  try { window.localStorage.setItem(storeKey(companyId), choice); } catch (e) { /* not available — fine */ }
};

/**
 * Turn a picker choice into the print option. null = the company's own header
 * (print exactly as before).
 */
export const letterheadForChoice = (choice, letterheads) => {
  if (choice === 'blank') return { kind: 'blank' };
  const l = (letterheads || []).find((x) => x.id === choice);
  if (!l) return null;
  return {
    kind: 'custom',
    name: String(l.name || '').trim(),
    address: String(l.address || '').trim(),
    phone: String(l.phone || '').trim(),
    email: String(l.email || '').trim(),
    ntn: String(l.ntn || '').trim(),
    salesTaxNo: String(l.salesTaxNo || '').trim(),
  };
};
